import { render, staticRenderFns } from "./CommercialForRent.vue?vue&type=template&id=5362d0c9&"
import script from "./CommercialForRent.vue?vue&type=script&lang=ts&"
export * from "./CommercialForRent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports